
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.704 5.706a1 1 0 10-1.415-1.414L.292 9.296a1 1 0 000 1.413l4.997 4.998a1 1 0 101.416-1.414L3.409 11H10a8 8 0 007.997-7.75L18 3a1 1 0 10-2 0 6 6 0 01-5.775 5.996L10 9H3.413z"}})])
          )
        }
      }
    